import type { UseFetchOutput } from '../useFetch';
import { useFetch } from '../useFetch'

/**
 * The default logic for basic registration
 */
export const useBasicRegister = ({ url }: any = {}): UseFetchOutput => {
  url = url ?? `/auth/basic/register`

  return useFetch(url)
}
